import {Item} from "../../@types/Item";
import {Item as ItemServer} from "../../API";

export const itemToItemServer = (itemClient: Partial<Item>): Partial<ItemServer> => {
    const serverReadyObj: Partial<ItemServer> = {...(itemClient as unknown as ItemServer)};
    if (typeof itemClient.childIds === 'object') {
        serverReadyObj.childIds = JSON.stringify(itemClient.childIds)
    }
    if (typeof itemClient.parentIds === 'object') {
        serverReadyObj.parentIds = JSON.stringify(itemClient.parentIds)
    }
    if (typeof itemClient.statusRestoreParentIds === 'object') {
        serverReadyObj.statusRestoreParentIds = JSON.stringify(itemClient.statusRestoreParentIds)
    }
    if (typeof itemClient.acknowledgement === 'object') {
        serverReadyObj.acknowledgement = JSON.stringify(itemClient.acknowledgement)
    }
    return serverReadyObj;
}
